import React, { useEffect } from "react";
import Dictaphone from "./Dictaphone";
import TextSpeech from "./TTS";
import { useState } from "react";
import Axios from "axios";

function Voice() {
	const [response, setResponse] = useState("");

	const handleDataFromChild = (data) => {
		setResponse(data);
	};

	return (
		<div className={"App"}>
			<div className=" h-screen w-full">
				<Dictaphone sendDataToParent={handleDataFromChild} />
				<TextSpeech text={response} />
			</div>
		</div>
	);
}

export default Voice;
